import { render, staticRenderFns } from "./image-logo.vue?vue&type=template&id=56f94b0e&lang=html&"
import script from "./image-logo.vue?vue&type=script&lang=js&"
export * from "./image-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports